import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { LocationsService } from "src/app/core/services/locations/locations.service";
import { environment } from "src/environments/environment";
import { ApiService } from "../../../../services/api";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
// import { CountryCode } from 'ngx-intl-tel-input';
@Component({
  selector: "app-transaction-receipt-modal-shared",
  templateUrl: "./transaction-receipt-modal-shared.component.html",
  styleUrls: ["./transaction-receipt-modal-shared.component.scss"],
})
export class TransactionReceiptModalSharedComponent implements OnInit {
  @Input() globalAmount: any;
  @Input() currency: any;
  @Input() globalOrderId: any;
  @Input() ModuleDetails: any;
  @Output() goToTransactionDetail: EventEmitter<any> = new EventEmitter();
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[];
  email: any = "";
  phone: any = "";
  emailMsg: any = "";
  errormsg: any = "";
  disableSendbtn = true;
  constructor(
    private http: HttpClient,
    private toastr: AlertService,
    private cookieService: CookieService,
    private ApiService: ApiService,
    private locationService: LocationsService
  ) {}
  GLOBALURL = this.ApiService.getBaseURL();
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  httpOptions = { headers: new HttpHeaders(this.headerToken) };
  merchantId: any = this.cookieService.get("merchantId");
  ngOnInit(): void {
    const userCountry = this.locationService.getUserCountry();
    this.preferredCountries = userCountry === CountryISO.UnitedKingdom
      ? [CountryISO.UnitedKingdom]
      : [userCountry, CountryISO.UnitedKingdom];
    if (!Boolean(this.currency)) {
      this.currency = "$";
    }
  }

  validateEmail() {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(this.email)) {
      this.emailMsg = "Please enter a valid email";
      return;
    } else {
      this.emailMsg = "";
    }
  }
  // validatePhone() {
  //   if (this.phone === "") {
  //     this.errormsg = true;
  //   } else {
  //     this.errormsg = false;
  //   }
  // }
  phoneMsg: boolean = false;

  validatePhone() {
    if (!this.phone) {
      // Handle empty phone number
      return;
    }

    console.log("THIS>PHONE_OBJ", this.phone);
    const phoneUtil = PhoneNumberUtil.getInstance();

    try {
      const phoneNumber = phoneUtil.parse(this.phone.internationalNumber);
      if (phoneUtil.isValidNumber(phoneNumber)) {
        // Valid phone number
        const formattedNumber = phoneUtil.format(
          phoneNumber,
          PhoneNumberFormat.NATIONAL
        );
        console.log("VALID_NUM", formattedNumber);
        this.phoneMsg = false; // No need to show a validation message
      } else {
        console.log("INVALID_NUM");
        this.phoneMsg = true; // Show a validation message
      }
    } catch (e) {
      console.log("INVALID_NUM");
      this.phoneMsg = true; // Show a validation message for invalid input
    }
  }

  sendReceiptMobile() {
    this.disableSendbtn = false;
    var params = {
      mobile: this.phone.internationalNumber,
      orderId: this.globalOrderId,
      merchantId: this.merchantId,
    };
    return this.http
      .post(this.GLOBALURL + "/receipt", params, this.httpOptions)
      .subscribe(
        (response: any) => {
          console.log("receipt", response);
          if (response.success === 1) {
            this.disableSendbtn = true;
            this.toastr.success(response.message);
            this.goToTransactionDetail.emit();
          } else {
            this.disableSendbtn = true;
            this.toastr.error(response.message);
          }
        },
        (error) => {
          this.disableSendbtn = true;
          this.toastr.error(error?.error?.message || error?.message || error);
        }
      );
  }

  sendReceiptToEmail() {
    this.disableSendbtn = false;
    var params = {
      email: this.email,
      orderId: this.globalOrderId,
      merchantId: this.merchantId,
    };
    return this.http
      .post(this.GLOBALURL + "/receipt", params, this.httpOptions)
      .subscribe(
        (response: any) => {
          console.log("email response", response);
          if (response.success === 1) {
            this.toastr.success(response.message);
            this.goToTransactionDetail.emit();
            this.disableSendbtn = true;
            //jQuery("#sendReceipts").modal("hide");
          } else {
            this.disableSendbtn = true;
            this.toastr.error(response.message);
          }
        },
        (error) => {
          this.disableSendbtn = true;
          this.toastr.error(error?.error?.message || error?.message || error);
        }
      );
  }
  getDynamicClass() {
    if (this.ModuleDetails === "servicecharge") {
      return "service-charge-main";
    } else if (this.ModuleDetails === "transaction") {
      return "send-width";
    } else if (this.ModuleDetails === "discount") {
      return "discount-main";
    }
  }
}
